<template>
    <div class="list-item">
        <div class="list-item-head">
            <h2 class="h4">{{ item.title }}</h2>

            <button
                @click="
                    open = !open;
                    $emit('opened');
                "
            >
                <svg class="icon">
                    <use v-if="open" xlink:href="#minus-solid" />
                    <use v-else xlink:href="#plus-outline" />
                </svg>
            </button>
        </div>

        <div v-if="open" class="list-item-details">
            <div>
                <h6 class="h6">Website</h6>
                <p>
                    <a :href="item.website" target="_blank">{{ item.website }}</a>
                </p>
            </div>

            <div>
                <h6 class="h6">Signatory since</h6>
                <p>
                    <span v-if="item.isFounding" class="loz loz--member">Founding</span>
                    {{ item.signingDate }}
                </p>
            </div>

            <div>
                <h6 class="h6">Region of operation</h6>
                <p>{{ item.regionOfOperation | join }}</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    filters: {
        join(array) {
            return array.join(', ');
        }
    },

    props: {
        item: {
            type: Object,
            required: true
        },
        activeMarker: {
            type: Object,
            default: null
        }
    },

    data() {
        return {
            open: false
        };
    },

    watch: {
        activeMarker: {
            immediate: true,
            handler(value) {
                this.open = value && value.id === this.item.id;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.list-item {
    padding: 1.5em 1em;
    border: 2px solid #e9e9e9;
    background-color: #ffffff;
    border-radius: 5px;
    margin: 1em 0;
    box-shadow: 0 1px 5px #e9e9e9;
}

.list-item-head {
    display: flex;
    align-items: center;

    .h4 {
        margin-right: 2em;
        font-size: 18px;
    }

    button {
        display: block;
        height: 24px;
        line-height: 24px;
        font-size: 24px;
        margin-left: auto;
        outline: none;
    }
}

.list-item-details {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 2em;
    margin: 2em 0 0;
    font-size: 16px;

    a {
        color: #ef6e0b;
    }
}

.loz {
    margin: 10px 10px 0 0;
}
</style>
